<template>
  <div class="footer">
    Copyright @ 2014 Naersi.com ALL Rights Reserved. <a href="http://beian.miit.gov.cn">粤ICP备17014349号</a>

  </div>

</template>

<script>
  export default {
    data () {
      return {}
    },
    components: {
    },
    ready() {

    }
  }
</script>

<style>
  .footer{border-top:0.02rem solid #000000;text-align: center;width: 9rem;margin:0.5rem auto 0.05rem auto;;font-size: 0.12rem;padding-top: 0.1rem; }
  @media screen and (max-width: 30em) and (min-width:20em ){
    .footer{width: 100%;margin: 0.2rem auto 0.05rem auto;}
  }
  .footer a{font-size: 0.12rem;color: #353434}

</style>



// WEBPACK FOOTER //
// footer.vue?d0238922